// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"406":"1e6896b3","445":"97df87a0"}[chunkId] + ".chunk.css";
};